




















import { defineComponent } from "@vue/composition-api";
import Vue from "vue";
import FormatMoney from "@/components/FormatMoney";

Vue.component("FormatMoney", FormatMoney);

export default defineComponent({
  name: "SubscriberIcon",
  props: {
    cost: { type: Number, required: true },
    color: { type: String, default: "var(--gradient-90deg)" },
  },
});
